module.exports = __webpack_public_path__ + "static/media/CloudDisk_004.785ed0b6.png";